(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.fancybox = {
    attach: function (context, settings) {

      // http://fancyapps.com/fancybox/3/docs/
      $().fancybox({
        selector: '.lightbox:not(.slick-cloned)',
      });

    }
  };

})(jQuery, Drupal, this, this.document);
